module.exports = __webpack_public_path__ + "static/media/rw.dbf846e1.svg";